export default "__VITE_ASSET__DP12MdUG__"